import { FeatureCollection, Point } from "geojson";

export const markersGeoJSONElipse: FeatureCollection<
  Point,
  { radiusX: number; radiusY: number; civic: any }
> = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 800 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.318267776284358, 45.445825444844274],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 900 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321090360522362, 45.44570285396321],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2900 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321283552719393, 45.44681182015475],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.323574090489728, 45.447314298593255],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.331648622787839, 45.44666876390531],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321878175501297, 45.44413070049322],
      },
    },

    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321878175501297, 45.44413070049322],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 50 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321760132026583, 45.44168833059513],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.324265981833008, 45.44265794929271],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1300 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.325915509962044, 45.444009158736066],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1600 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.328152936094028, 45.44343253347594],
      },
    },

    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.330895143018267, 45.44350212458184],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1800 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.330793707940302, 45.44460721569351],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.333258696084016, 45.4443191291098],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3600 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.3345020885765, 45.44328147956037],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 4000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.335554129288965, 45.44078938094637],
      },
    },

    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 5000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.340494841984622, 45.44287190930805],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 6300 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.341722662875014, 45.44116148260392],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 6000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.339586008036889, 45.43920476407203],
      },
    },

    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: `1 - 100 ` }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.361666688683187, 45.42780131038327],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 700 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.357084131650197, 45.43125554314727],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: `1 - 70` }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.359702216650902, 45.433324448367074],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.353247504966163, 45.43229391603845],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.350353451221537, 45.43275165085532],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.348765892562966, 45.435604041696195],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.347161593933293, 45.43501253168208],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.347354764813929, 45.43706094854531],
      },
    },

    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2700 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.348950013503213, 45.43829959482974],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 6500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.343747011731466, 45.438658401334976],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 6000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.341795077454236, 45.43826055514157],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 5500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.338523048924259, 45.437904926764645],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 5000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.336927980622221, 45.43800148128932],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 4500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.342465430379065, 45.43515336876544],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 5000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.344351400723298, 45.43684905700232],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.338947566290244, 45.435905615689364],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 50 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.338003418896932, 45.434242841044124],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.335957500970864, 45.434180213775164],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.335957500970864, 45.434180213775164],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 4000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.334014716257997, 45.43541478873166],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.332204432105613, 45.43306494449746],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.329356982379238, 45.43382674303675],
      },
    },
    //
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.331161766237983, 45.44084544145602],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.327334639397804, 45.44035453351921],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.32496680713703, 45.4410730350115],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 700 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.323078444998345, 45.44051778146476],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 800 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.32484810239211, 45.438935653796335],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 600 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321920229785519, 45.43895662500236],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 200 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321843393298508, 45.43756372094438],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 50 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.323942418339868, 45.436149232147415],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 300 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.318476512964196, 45.43565683174003],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 400 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.317104367398315, 45.43654604346062],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.317496230152955, 45.43937710265601],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2300 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.330415126248766, 45.43914834456939],
      },
    },
    // san polo
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 50 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.335038710385248, 45.43875235497026],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 600 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.33471878638909, 45.43816399208839],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 900 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.333505781024968, 45.43847046904787],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1800 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.332435940964302, 45.439769435762855],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 200 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.33423721067453, 45.43929576826616],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1100 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.33280237011249, 45.43729946404048],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.33041841635142, 45.43805557971436],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2800 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.328614002578774, 45.436264185826644],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.32726323712211, 45.43814666436077],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.324189377213258, 45.43735127935605],
      },
    },
    //dorsoduro
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 100 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.333996377666324, 45.430171044917415],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 600 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.330394550775083, 45.4297465107675],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 900 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.327386709106236, 45.43024976262666],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1100 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.325327787496121, 45.431173089210716],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.324189377213258, 45.43735127935605],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2700 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.324905857876388, 45.432930411805415],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3200 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.325271316864615, 45.4339434355993],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3800 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.326267844972534, 45.43526401746013],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 3500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321678416851881, 45.43548483148393],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.320307101095182, 45.43325071388125],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 1500 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.321138722766221, 45.43178117736127],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2300 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.318328711082955, 45.43363219006335],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 2000 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.313678308012896, 45.43233086242381],
      },
    },

    // Guidecca
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 50 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.337842366536336, 45.42640151215497],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 200 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.329154299679601, 45.42462465042536],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 400 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.326793443646238, 45.42444453891892],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 600 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.323053873363875, 45.42554582272507],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: 800 }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.3199093675685, 45.42763116919434],
      },
    },
    {
      type: "Feature",
      properties: { radiusX: 40, radiusY: 30, civic: `1-30` }, // X and Y axes in *pixels*
      geometry: {
        type: "Point",
        coordinates: [12.315634218905984, 45.42750665665304],
      },
    },
  ],
};
